import { ActionType } from "../actionTypes/index";

const initialState = {
  programs: [],
  event: null,
};

const programsReducer = (state = initialState, action: any): any => {
  switch (action.type) {
    case ActionType.GET_ALL_PROGRAMS:
      return {
        ...state,
        programs: action.payload.data.results,
        event: action.type,
      };
    case ActionType.GET_ALL_PROGRAMS_FAILED:
      return {
        ...state,
        event: action.type,
      };
    default:
      return state;
  }
};

export default programsReducer;
